import { lazyLoad } from '@/lib/LazyLoad';

export const SlackPage = lazyLoad(
  () => import('./SlackPage'),
  (module) => module.SlackPage
);
